import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Hydrodtls from '../MenserviceHydro/Hydrodtls'
import Footer from '../Footer/Main'
import ItRecruitment from '../ITRecruitment/ItRecruitment'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="IT Recruitment" />
                <ItRecruitment />
                <Footer />
            </div>
        </>
    )
}

export default Main